import React from 'react';
// import SaveNav from 'components/SaveNav';
import BorrowNav from 'components/BorrowNav';
// import TradeNav from 'components/TradeNav';
import { Flex, Grid, Box } from '@makerdao/ui-components-core';
import HakerDaoLogo from '../images/hayker-dao/pc/deposite-logo.png';
import useMaker from 'hooks/useMaker';
import useLanguage from 'hooks/useLanguage';

// baker样式
import 'bakerdao/css/pc/left/logo.css'

// baker logo图
import BkrLogo from 'bakerdao/images/BKRlogo.png'


const Navbar = ({ viewedAddress }) => {
  const { account } = useMaker();
  const { lang } = useLanguage();
  const gotoHome = () => {
    window.open('https://www.hkrdao.com', '_blank');
  };

  return (
    <Box
      // style={{ borderRight: '1px solid rgba(190,190,190,0.4)',height:'100vh' }}
      bg={account ? 'blueGray' : 'white'}
      height="100%"
    >
      <Flex
        style={{ marginTop: '20px' }}
        alignItems="center"
        justifyContent="center"
        py="m"
      >
        <div
          // baker样式
          className="baker-overview-logo"
          style={{
            // width: '55px',
            // width: '80px',
            // height: '55px',
            // height: '65px',
            'background-color': '#f6f8f9',
            // display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '3px',
            flexWrap: 'wrap',
            padding: '4px 0',
            cursor: 'pointer'
          }}
          onClick={gotoHome}
        >
          <img
            style={{ display: 'block' }}
            width="25px"
            height="25px"
            src={BkrLogo}
          />
          <p style={{ fontSize: '14px'}}>{lang.app_name}</p>
          {/* <p style={{fontSize:'12px',fontWeight:'bold'}}>公测版</p> */}
        </div>
      </Flex>
      <Grid mx="0px">
        {/* <SaveNav account={account} /> */}
        <BorrowNav viewedAddress={viewedAddress} account={account} />
        {/* <TradeNav /> */}
      </Grid>
    </Box>
  );
};

export default Navbar;
